import axios from "axios";
import { clearAllCookies, clearItem, getItem } from "../view/Utils/CommonFunction/CommonFunction";
import { GET_SFTP_USER } from "../common/config";

const prepareHeaders = () => {
    const accessToken = getItem('accessToken');
    return {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    };
};

export const SftpUserService = async (payload) => {
    try {
        const response = await axios({
            method: 'get',
            url: GET_SFTP_USER,
            headers: prepareHeaders().headers,
            data: payload,
        });
        return response;
    } catch (error) {
        if (error?.response?.status == 401) {
            window.location.reload()
            clearAllCookies();
            clearItem();
        }
        return error;
    }
};
